import { Box, Typography } from "@drone-js/core";

export const MainPhotoBadge = () => {
    return (
        <Box
            py="4"
            px="8"
            borderRadius="4"
            position="absolute"
            left="8px"
            top="8px"
            backgroundColor="base.surface"
            zIndex={2}
        >
            <Typography variant="body-s-strong">Main photo</Typography>
        </Box>
    );
};
